import * as React from 'react'

import { FormHelperText } from '@material-ui/core'
import styled from 'styled-components'

import { type IFieldHelperTextProps } from '../FieldHelperText'

export const FieldHelperTextStyled = styled((props: IFieldHelperTextProps) => {
  return (
    <FormHelperText
      classes={{
        disabled: 'formLabelDisabled',
        error: 'formLabelError',
      }}
      {...props}
    />
  )
})`
  && {
    font-family: inherit;
    font-weight: ${(props) => props.theme.fontWeights.normal};
    color: ${(props) => props.theme.colors.text.primary};
    font-size: ${(props) =>
      props.theme.typography.pxToRem(props.theme.fontSizes.caption)};
    margin-top: ${(props) => props.theme.typography.pxToRem(4)};
    line-height: 1.5;
    &.formLabelDisabled {
      color: ${(props) => props.theme.colors.text.primary};
    }
    &.formLabelError {
      color: ${(props) => props.theme.colors.error} !important;
    }
    letter-spacing: 0;
  }
`
